import React from "react";
import { connect } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import PortfolioPanel from "./PortfolioPanel";
import DealPanel from "./DealPanel";
import ContentContainer from "../common/ContentContainer";
import DailyPnlPanel from "./DailyPnlPanel";
import "./Dashboard.scss";
import TopTemplatesPanel from "./TopTemplatesPanel";
import NewUserTour from "../tour/NewUserTour";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const { t } = useTranslation()
  return (
    <ContentContainer url="dashboard" title={t("dashboard")} showExchange={true}>
      <div className="dashboard">
        <Row noGutters className="top-row">
          <Col xs={12} xl={7}>
            <div>
              <PortfolioPanel t={t}/>
            </div>
          </Col>
          <Col xs={12} xl={5}>
            <div>
              <DailyPnlPanel t={t}/>
            </div>
          </Col>
        </Row>
        <Row className="bottom-row" noGutters>
          <Col xs={12} xl={7}>
            <div>
              <DealPanel t={t}/>
            </div>
          </Col>
          <Col xs={12} xl={5}>
            <div>
              <TopTemplatesPanel t={t}/>
            </div>
          </Col>
        </Row>
      </div>
    </ContentContainer>
  );
};

export default connect(null)(Dashboard);
